import { Component, OnInit } from '@angular/core';
import { UserService } from '@universis/common';
import { AngularDataContext } from '@themost/angular';
import { ProfileService } from '../../services/profile.service';
import { LinkProfile, NgxProfilesService } from '@universis/ngx-profiles';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss']
})
export class ProfileCardComponent implements OnInit {

  public profile: any = {
    person: {
      name: "Aliquamed Volutpatortor"
    },
    studyProgram: {
      name: "Vivamus quis elit eget odio porta egestas elit",
    },
    department: {
      name: "In hac habitasse platea dictumst"
    },
    studentStatus: {
      name: "Nullam tincidunt"
    },
    inscriptionPeriod: {
      name: "Tinci"
    },
    inscriptionYear: 2000
  };
  public loading: boolean = true;
  public studentProfiles = [];


  constructor(private _userService: UserService,
    private context: AngularDataContext,
    public profileService: ProfileService,
    public profiles: NgxProfilesService) {
    //
  }

  ngOnInit() {
    this.profileService.student$.subscribe((student) => {
      this.profile = student;
      this.loading = false;
    });
  }

  switchProfile(profile: LinkProfile) {
    this.profiles.setStudentProfile(profile);
    window.location.reload();
  }

}
